import { styled } from '@mui/material'

import { StackWrapper } from '../wrapper'

export const StackFullScreen = styled(StackWrapper)(() => ({
  width: '100%'
}))
